import { useSyncExternalStore } from 'react';

const emptySubscribe = () => () => {
};
function useIsSSR() {
  const isSSR = useSyncExternalStore(
    emptySubscribe,
    () => false,
    () => true
  );
  return isSSR;
}

export { useIsSSR };
//# sourceMappingURL=useIsSSR.mjs.map
